import { useGetUserUnits } from "@/queries/users/users.api";
import { useEffect, useState } from "react";

const useUserUnitCatalog = () => {
  const { data, isLoading, isFetching } = useGetUserUnits();

  const [unit, setUnit] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);

  useEffect(() => {
    setUnit(
      data?.data.map((r: { nombre: string; id: string }) => {
        return {
          label: r.nombre,
          value: r.id,
        };
      }) || [],
    );
  }, [data]);

  return {
    unit,
    isLoading,
    isFetching,
  };
};

export default useUserUnitCatalog;
